import styled from "@emotion/styled";

const SectionWrapper = styled.div`
  padding: ${(props) => (props.p ? props.p : "0px 0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  @media screen and (max-width: 599px) {
  }
`;
const P = styled.p`
  font-family: "Lucida-Regular";
  font-size: ${(props) => (props.fs ? props.fs : "16px")};
  color: ${(props) => (props.color ? props.color : "#FFF")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "100%")};
  text-align: ${(props) => (props.align ? props.align : "left")};
  padding: ${(props) => (props.p ? props.p : "20px 0")};
  margin: 0;
  @media (max-width: 1100px) {
    padding: 0;
    font-size: 14px;
    max-width: 100%;
  }
  @media (max-width: 1440px) and (max-height: 620px) {
    padding-top: ${(props) => (props.pt630 ? props.pt630 : "10px 0")};
  }
`;
const CustomContainer = styled.div`
  max-width: 2600px;
`;
const SectionHeading = styled.h2`
  font-family: "Glitch-inside";
  word-break: keep-all;
  text-align: left;
  color: #fff;
  font-size: ${(props) => (props.fs ? props.fs : "65px")};
  color: #a2ffec;
  letter-spacing: ${(props) => (props.ls ? props.ls : "6px")};
  text-shadow: 0 0 10px #00fdca;
  background-size: cover;
  background-clip: text;
  -webkit-background-clip: text;
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  @media (max-width: 899px) {
    padding: 50px 0 0 0;
    font-size: 70px;
  }
  @media (max-width: 599px) {
    letter-spacing: 0px;
    font-size: 30px;
    /* padding: ${(props) => (props.P599 ? props.p599 : "0px 0")};
    line-height: unset;
    font-size: 40px; */
  }
`;
const SectionSubHeading = styled.h3`
  /* text-align: center; */
  color: #fff;
  font-size: ${(props) => (props.fs ? props.fs : "50px")};
  font-family: "Lucida-Regular";
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.m ? props.m : "0")};
  @media (max-width: 899px) {
    font-size: 50px;
  }
  @media (max-width: 599px) {
    padding: ${(props) => (props.P599 ? props.p599 : "0px 0")};
    line-height: unset;
    font-size: 40px;
  }
`;
const SectionSmallHeading = styled.h3`
  font-family: "Lucida-Regular";
  font-size: ${(props) => (props.fs ? props.fs : "25px")};
  color: ${(props) => (props.color ? props.color : "#59311A")};
  padding: ${(props) => (props.p ? props.p : "0")};
  margin: ${(props) => (props.p ? props.p : "0")};
  line-height: ${(props) => (props.lh ? props.lh : "")};
  max-width: ${(props) => (props.mw ? props.mw : "100%")};
  text-align: ${(props) => (props.align ? props.align : "center")};

  @media (max-width: 599px) {
    line-height: ${(props) => (props.lh ? props.lh : "")};
    max-width: 100%;
    font-size: ${(props) => (props.fs599 ? props.fs599 : "")};
  }
`;

const Bg = styled.div`
  position: fixed;
  background-image: url("/images/leftslide.png");
  display: table-caption;
  background-size: cover;
  background-position: top right;
  height: 100vh;
  width: 50px;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  z-index: 1;
  @media screen and (max-width: 600px) {
    align-items: center;
    justify-content: center;
    left: 0;
    right: 0;
    width: 100%;
    height: 50px;
    bottom: 0;
  }
`;
const Position = styled.div`
  position: absolute;
  left: 0;
  @media screen and (max-width: 600px) {
    position: unset;
  }
`;
const Hello = styled.div`
  padding: 0px 0px;
  font-size: 10px;
  width: 45px;
  text-align: center;

  @media screen and (max-width: 600px) {
    width: 100%;
  }
`;
const A = styled.a`
  font-size: 50px;
  @media screen and (max-width: 600px) {
    margin: 0 8px;
  }
`;
const Spanfollow = styled.span`
  font-size: 18px;
  text-align: center;
  display: block;
  transform: rotate(-90deg) translate(56px, -60px);
  width: 166px;
  @media screen and (max-width: 600px) {
    display: none;
  }
`;
export {
  SectionWrapper,
  P,
  SectionHeading,
  SectionSubHeading,
  CustomContainer,
  SectionSmallHeading,
  Bg,
  Position,
  Hello,
  A,
  Spanfollow,
};
